import React, { Component } from "react"
import { API } from "../../API";

export default class Confirm extends Component {
  // A bit of state to give the user feedback while their email
  // address is being confirmed on the User model on the server.
  // state = {
  //   confirming: true
  // }

  // When the component mounts the mongo id for the user is pulled  from the
  // params in React Router. This id is then sent to the server to confirm that
  // the user has clicked on the link in the email. The link in the email will
  // look something like this:
  //
  // http://localhost:3000/confirm?id=5c40d7607d259400989a9d42
  //
  // where 5c40d...a9d42 is the unique id created by Mongo
  componentDidMount = async () => {
    const id = window.location.search.substring(1).split("id=")[1]
    await API.confirmCustomer(id)
      .then((res) => {
        const path = res.data.customer.contact_number_verified
          ? { pathname: "/alreadyregistered" }
          : {
              pathname: "/secondaryRegistrationCollege",
              state: res.data.customer,
            }
        this.props.history.push(path)
      })
      .catch((err) => {
        console.log(err)
        this.props.history.push("/login")
      })
  }

  render = () => <div />
}
